import { HolidaysInterface, rentalPointScheduleInterface } from "../types/types";
import { format, getDay, isSameDay, isWeekend, isWithinInterval, parseISO } from 'date-fns'
import { RentalPointName } from "./RentalPointName";
import { getBookingConfig } from "./price";

export class HolidaysManager{


    constructor(protected holidays: HolidaysInterface, private rentalPoints: rentalPointScheduleInterface) {
    }

    protected dateInArray(dateArray: string[], date: Date) {
        return dateArray.some((dateStr) => {
            return isSameDay(parseISO(dateStr), date);
        })
    }

    public isTransForceHoliday(date: Date) {
        if (isWeekend(date)) {
            return true;
        }
        if (this.dateInArray(this.holidays.deliveryHolidays, date)) {
            return true;
        }
        if (this.dateInArray(this.holidays.globalHolidays, date)) {
            return true;
        }

        return false;
    }

    public countDPDHolidaysInsideInterval(interval: Interval) {
        //get unique list of delivery && global holidays
        let holidays = Array.from(new Set([...this.holidays.deliveryHolidays, ...this.holidays.globalHolidays]));
        //count number of holidays in given interval
        return holidays.reduce((previousValue, currentValue) => {
            if (isWithinInterval(parseISO(currentValue), interval)) {
                return previousValue + 1;
            }
            return previousValue;
        }, 0);
    }

    public isAnyRentalPointWorking(date: Date) {
        return this.checkAnyRentalPointsIsWorking(date, (id) => {
            return true;
        });
    }

    public isOurRentalPointWorking(date: Date) {

        return this.checkAnyRentalPointsIsWorking(date, (id) => {
            return id === RentalPointName.HERENT || id === RentalPointName.HASSELT
        });
    }

    protected checkAnyRentalPointsIsWorking(date: Date, filterFn: (id: number) => boolean) {
        const dateStr = format(date, "yyyy-MM-dd");
        const rentalPointsIds = Object.keys(this.rentalPoints).map(id => parseInt(id, 10)).filter(filterFn);
        const weekDay = getDay(date);
        const normallyWorkingRentalPoints = rentalPointsIds.filter((id) => {
            console.log(getBookingConfig().exceptionallyOpen);
            return this.rentalPoints[id].includes(weekDay) || getBookingConfig().exceptionallyOpen[id].includes(dateStr);
        });

        return normallyWorkingRentalPoints.some((id) => {
            return !this.holidays.holidays[id].includes(dateStr) && !this.holidays.globalHolidays.includes(dateStr);
        });
    }

    public isRentalPointWorking(point: number, date: Date) {

        return this.checkAnyRentalPointsIsWorking(date, (id) => {
            return id === point
        });
    }
}

